import React from 'react';
import { FaFileAlt, FaEnvelope } from 'react-icons/fa';

const DocumentStats = ({ totalResumes, totalCoverLetters }) => {
  return (
    <div className="stats-card document-stats">
      <h2>Document Statistics</h2>
      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-icon">
            <FaFileAlt />
          </div>
          <div className="stat-content">
            <h3>Total Resumes</h3>
            <p className="stat-value">{totalResumes}</p>
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaEnvelope />
          </div>
          <div className="stat-content">
            <h3>Total Cover Letters</h3>
            <p className="stat-value">{totalCoverLetters}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentStats;